/**
 *  Filter options in collection filters
 */
class FilterOptions extends HTMLElement {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.cacheDOM();
    this.eventListener();
  }

  /**
   * Class method to cache needed elements
   */
  cacheDOM() {
    this.refs = {};
    this.refs.input = this.querySelector('[custom-filter-options]');
    this.refs.wrapper = this.closest('[data-custom-option-wrapper]');
    this.refs.list = this.refs.wrapper.querySelector('[data-custom-option-list]');
    this.refs.options = this.refs.list.querySelectorAll('[data-custom-option-value]');
  }

  /**
   * Class method to listening for events
   */
  eventListener() {
    // this.refs.input.addEventListener('input', (e) => this.filterOptions(e));
    this.refs.input.addEventListener('input', this.filterOptions.bind(this));
  }

  /**
   * Method to show/hide options
   *
   * @param {Event} e event
   */
  filterOptions(e) {
    e.stopPropagation();
    this.refs.options.forEach((option) => {
      const regex = new RegExp(e.target.value, 'gi');
      const match = option.dataset.customOptionValue.match(regex);
      if (match == null) option.classList.add('visually-hidden');
      else option.classList.remove('visually-hidden');
    });
  }
}

customElements.define('filter-options', FilterOptions);
